import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen } from "react-icons/fa";
import * as SR_SubTypeService from "../../../Services/Masters/SR_SubType/SR_SubTypeService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const SR_SubTypeComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [caseOriginList, setSR_SubTypeList] = useState([]);
    const [selectedSR_SubType, setSelectedSR_SubType] = useState({});
    const [newSR_SubTypeModal, setNewSR_SubTypeModal] = useState(false);

    const fetchAllSR_SubTypeMasterList = () => {
        SR_SubTypeService.GetSR_SubTypeList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setSR_SubTypeList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllSR_SubTypeMasterList();
        if (caseOriginList.length > 0) {
          //console.log("Updated caseOriginList:", caseOriginList);
        }
    },[]);

    const onSubmit = (data) => {
      if (selectedSR_SubType?.SrSubTypeId) {
        data.SrSubTypeId = selectedSR_SubType?.SrSubTypeId;
        SR_SubTypeService.UpdateSR_SubType(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllSR_SubTypeMasterList();
              toast.success("SR SubType updated successfully!");
              handleNewSR_SubTypeModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        SR_SubTypeService.CreateNewSR_SubType(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllSR_SubTypeMasterList();
              toast.success("SR SubType saved successfully!");
              handleNewSR_SubTypeModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewSR_SubTypeModalClose = () => {
      reset();
      setSelectedSR_SubType([]);
      setNewSR_SubTypeModal(false)
    };

    const handleActivateDeActivateSR_SubType = (rec) =>{
      SR_SubTypeService.ActivateDeActivateSR_SubType(rec.SrSubTypeId, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "SR SubType DeActivated Successfully" : "SR SubType Activated Successfully";
          toast.success(message);
          fetchAllSR_SubTypeMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewSR_SubTypeDetailById = (SrSubTypeId) => {
      //debugger;
      const selectedItem = caseOriginList.find(item => item.SrSubTypeId === SrSubTypeId);
      if(selectedItem != null){
        setSelectedSR_SubType(selectedItem);
        setNewSR_SubTypeModal(true);
      }
      else{
        selectedSR_SubType({});
      }
    };

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="SR SubType List" buttonText="Add SR SubType" onButtonClick={() => { reset(); setSelectedSR_SubType([]); setNewSR_SubTypeModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> SR SubType</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      caseOriginList.length > 0 ? (
                        caseOriginList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.SubTypeName}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate SR_SubType" onClick={() => handleActivateDeActivateSR_SubType(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateSR_SubType(rec)} title="Activate SR_SubType" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewSR_SubTypeDetailById(rec.SrSubTypeId)} title="Edit SR_SubType" />
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newSR_SubTypeModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedSR_SubType?.SR_SubType ? "Edit SR SubType" : "New SR SubType"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewSR_SubTypeModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">SR SubType</label>
                              <input type="text" className="form-control" placeholder="Enter SR SubType" {...register("SubTypeName", { required: "SR SubType is required" })} defaultValue={selectedSR_SubType?.SubTypeName || ""} />
                              {errors.SR_SubType && <p className="text-danger required_error">{errors.SR_SubType.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewSR_SubTypeModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedSR_SubType?.SrSubTypeId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default SR_SubTypeComponent